module.exports = __webpack_public_path__ + "img/s00132.145c15d3.png";